import React, { useState, useEffect } from 'react';
import { buscarDni } from '../../../services/DniService';
import { guardarCliente, getClientes, actualizarCliente, eliminarCliente } from '../../../services/ClientesService'; 

// Estilos
import '../../static/Global.css';
import '../../static/Home.css';
import '../../static/Aside.css';
import '../../static/Flotante.css';
import '../../static/Busqueda.css';

function DashboardClientes() {
    const [clientes, setClientes] = useState([]);
    const [busqueda, setBusqueda] = useState("");
    const [loading, setLoading] = useState(true);
    const [loadingDni, setLoadingDni] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);

    // 1. MODIFICADO: Agregamos 'num_cel' al estado inicial del formulario
    const [formData, setFormData] = useState({
        id: '',
        dni: '',
        nombres: '',
        apellido_paterno: '',
        apellido_materno: '',
        email: '',
        num_cel: '', 
        comentarios: ''
    });

    useEffect(() => {
        cargarLista();
    }, []);

    // LEER CLIENTES
    const cargarLista = async () => {
        setLoading(true);
        try {
            const data = await getClientes(); 
            setClientes(data);
            setLoading(false);
        } catch (error) {
            console.error("Error cargando clientes:", error);
            setLoading(false);
        }
    };

    // CONSULTAR DNI (RENIEC)
    const handleConsultarDni = async () => {
        if (formData.dni.length !== 8) {
            alert("El DNI debe tener exactamente 8 dígitos.");
            return;
        }

        setLoadingDni(true);
        try {
            const data = await buscarDni(formData.dni);
            
            if (data.success) {
                setFormData(prev => ({
                    ...prev,
                    nombres: data.nombres,
                    apellido_paterno: data.apellido_paterno,
                    apellido_materno: data.apellido_materno
                }));
            }
        } catch (error) {
            alert(error.message);
        } finally {
            setLoadingDni(false);
        }
    };

    // CREAR O ACTUALIZAR CLIENTE
    const handleSave = async (e) => {
        e.preventDefault();
        try {
            if (formData.id) {
                // Si existe un ID, estamos editando
                await actualizarCliente(formData);
                alert("¡Cliente actualizado con éxito!");
            } else {
                // Si no hay ID, es un registro nuevo
                await guardarCliente(formData);
                alert("¡Cliente registrado con éxito!");
            }
            closeModal();
            cargarLista(); // Refresca los cambios
        } catch (error) {
            alert("Error al procesar: " + error.message);
        }
    };

    // ELIMINAR CLIENTE
    const handleDelete = async (id, nombres) => {
        if (window.confirm(`¿Estás seguro de que deseas eliminar al cliente ${nombres}?`)) {
            try {
                await eliminarCliente(id);
                alert("Cliente eliminado correctamente.");
                cargarLista(); // Refresca la tabla
            } catch (error) {
                alert("Error al eliminar: " + error.message);
            }
        }
    };

    // Filtro de búsqueda (Opcional: puedes agregar || c.num_cel?.includes(busqueda) si deseas buscar por número)
    const clientesFiltrados = clientes.filter(c => 
        c.nombres?.toLowerCase().includes(busqueda.toLowerCase()) ||
        c.apellidos?.toLowerCase().includes(busqueda.toLowerCase()) ||
        c.dni?.toString().includes(busqueda)
    );

    const openModal = (cliente = null) => {
        if (cliente) {
            // Mapeo para edición desestructurando apellidos
            const partesApellidos = cliente.apellidos ? cliente.apellidos.split(' ') : [];
            // 2. MODIFICADO: Mapeamos 'num_cel' desde el registro de la BD al abrir edición
            setFormData({
                id: cliente.id,
                dni: cliente.dni || '',
                nombres: cliente.nombres || '',
                apellido_paterno: partesApellidos[0] || '',
                apellido_materno: partesApellidos.slice(1).join(' ') || '', 
                email: cliente.email || '',
                num_cel: cliente.num_cel || '', 
                comentarios: cliente.comentarios || ''
            });
        } else {
            // Limpieza del formulario al registrar uno nuevo
            setFormData({
                id: '',
                dni: '',
                nombres: '',
                apellido_paterno: '',
                apellido_materno: '',
                email: '',
                num_cel: '', 
                comentarios: ''
            });
        }
        setIsModalOpen(true);
    };

    const closeModal = () => setIsModalOpen(false);

    return (
        <section className="main__content">
            <div className="table-container">
                <div className="table-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', gap: '20px' }}>
                    <h2>GESTIÓN DE CLIENTES</h2>
                    
                    <div className="search-container">
                        <i className="fa fa-search" style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#888' }}></i>
                        <input 
                            type="text"
                            className="search-input"
                            placeholder="Buscar por DNI, nombres o apellidos..."
                            style={{ paddingLeft: '35px', width: '100%', borderRadius: '8px', border: '1px solid #ddd', height: '40px' }}
                            value={busqueda}
                            onChange={(e) => setBusqueda(e.target.value)}
                        />
                    </div>

                    <button type="button" className="btn-vender-sidebar" onClick={() => openModal()}>
                        <i className="fa fa-plus"></i> Registrar Nuevo Cliente
                    </button>
                </div>

                <div className="table-responsive">
                    <table className="novatech-table">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>DNI</th>
                                <th>Nombres</th>
                                <th>Apellidos</th>
                                <th>Celular</th> 
                                <th>Email</th>
                                <th>Comentarios</th>
                                <th>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr><td colSpan="8">Cargando clientes...</td></tr>
                            ) : clientesFiltrados.length > 0 ? (
                                clientesFiltrados.map((c) => (
                                    <tr key={c.id}>
                                        <td>#{c.id}</td>
                                        <td style={{ fontWeight: 'bold' }}>{c.dni}</td>
                                        <td>{c.nombres}</td>
                                        <td>{c.apellidos}</td>
                                        <td>{c.num_cel || 'N/A'}</td>
                                        <td>{c.email || 'N/A'}</td>
                                        <td>{c.comentarios || 'Sin comentarios'}</td>
                                        <td className="actions-cell" style={{ display: 'flex', gap: '8px' }}>
                                            {/* Botón Editar */}
                                            <button className="btn-edit" onClick={() => openModal(c)} title="Editar Cliente">
                                                <i className="fa fa-edit"></i>
                                            </button>
                                            {/* Botón Eliminar */}
                                            <button className="btn-delete" onClick={() => handleDelete(c.id, c.nombres)} style={{ background: '#e03e2d', color: '#fff', border: 'none', padding: '6px 10px', borderRadius: '4px', cursor: 'pointer' }} title="Eliminar Cliente">
                                                <i className="fa fa-trash"></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr><td colSpan="8" style={{ textAlign: 'center', padding: '20px' }}>No se encontraron clientes con "{busqueda}"</td></tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {isModalOpen && (
                <div className="modal" style={{ display: 'flex' }}>
                    <div className="modal-content" style={{ maxWidth: '500px', width: '100%' }}>
                        <form onSubmit={handleSave}>
                            <h2>{formData.id ? "EDITAR CLIENTE" : "REGISTRAR CLIENTE"}</h2>
                            
                            <div className="form-group">
                                <label>DNI del Cliente:</label>
                                <div style={{ display: 'flex', gap: '10px' }}>
                                    <input 
                                        type="text" 
                                        maxLength={8}
                                        value={formData.dni} 
                                        required 
                                        style={{ flex: 1 }}
                                        placeholder="Ingresa 8 dígitos"
                                        disabled={!!formData.id} 
                                        onChange={(e) => setFormData({...formData, dni: e.target.value.replace(/\D/g, '')})} 
                                    />
                                    {!formData.id && (
                                        <button 
                                            type="button" 
                                            onClick={handleConsultarDni} 
                                            disabled={loadingDni}
                                            style={{ padding: '0 15px', background: '#0070f3', color: '#fff', border: 'none', borderRadius: '5px', cursor: 'pointer' }}
                                        >
                                            {loadingDni ? 'Buscando...' : 'Buscar RENIEC'}
                                        </button>
                                    )}
                                </div>
                            </div>

                            <div className="form-group">
                                <label>Nombres:</label>
                                <input 
                                    type="text" 
                                    value={formData.nombres} 
                                    required 
                                    readOnly={!formData.id} 
                                    placeholder="Se rellenará automáticamente" 
                                    onChange={(e) => setFormData({...formData, nombres: e.target.value})}
                                />
                            </div>

                            <div style={{ display: 'flex', gap: '15px' }}>
                                <div className="form-group" style={{ flex: 1 }}>
                                    <label>Apellido Paterno:</label>
                                    <input 
                                        type="text" 
                                        value={formData.apellido_paterno} 
                                        required 
                                        readOnly={!formData.id} 
                                        placeholder="Automático" 
                                        onChange={(e) => setFormData({...formData, apellido_paterno: e.target.value})}
                                    />
                                </div>
                                <div className="form-group" style={{ flex: 1 }}>
                                    <label>Apellido Materno:</label>
                                    <input 
                                        type="text" 
                                        value={formData.apellido_materno} 
                                        readOnly={!formData.id} 
                                        placeholder="Automático" 
                                        onChange={(e) => setFormData({...formData, apellido_materno: e.target.value})}
                                    />
                                </div>
                            </div>

                            {/* 4. MODIFICADO: Añadido el campo de entrada para Celular */}
                            <div className="form-group">
                                <label>Número de Celular (Opcional):</label>
                                <input 
                                    type="text" 
                                    maxLength={15} // Por si ingresan prefijos (+51)
                                    value={formData.num_cel} 
                                    placeholder="Ej: 906145083"
                                    onChange={(e) => setFormData({...formData, num_cel: e.target.value})} 
                                />
                            </div>

                            <div className="form-group">
                                <label>Correo Electrónico (Opcional):</label>
                                <input 
                                    type="email" 
                                    value={formData.email} 
                                    onChange={(e) => setFormData({...formData, email: e.target.value})} 
                                    placeholder="ejemplo@correo.com"
                                />
                            </div>

                            <div className="form-group">
                                <label>Comentarios / Notas:</label>
                                <textarea 
                                    value={formData.comentarios} 
                                    onChange={(e) => setFormData({...formData, comentarios: e.target.value})} 
                                    placeholder="Observaciones sobre el cliente..."
                                    style={{ width: '100%', height: '70px', borderRadius: '6px', padding: '8px', border: '1px solid #ddd', resize: 'none' }}
                                />
                            </div>

                            <div className="actions" style={{ marginTop: '20px' }}>
                                <button type="submit" className="btn-save" disabled={!formData.nombres}>
                                    {formData.id ? "Actualizar Cambios" : "Guardar Cliente"}
                                </button>
                                <button type="button" className="btn-cancel" onClick={closeModal}>Cancelar</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </section>
    );
}

export default DashboardClientes;